exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-wrapper {\n  position: relative;\n  width: 100%;\n  height: 42px;\n  line-height: 42px;\n  border-bottom: 1px solid #333333;\n  font-size: 14px;\n  color: #666666;\n  cursor: pointer;\n}\n.arrow-down {\n  position: absolute;\n  top: 18px;\n  right: 10px;\n  width: 4px;\n  height: 4px;\n  border-bottom: 1px solid #ffffff;\n  border-left: 1px solid #ffffff;\n  transform: rotate(-45deg);\n}\n.options {\n  position: absolute;\n  width: 100%;\n  top: 41px;\n  background: #1e1e1e;\n  box-shadow: rgba(0, 0, 0, 0.2);\n  z-index: 6;\n  max-height: 290px;\n}\n.options p {\n  margin: 0;\n  padding: 0 10px;\n}\n.options p:hover {\n  color: #fff;\n}\n@media screen and (max-width: 1400px) {\n  .dropdown-wrapper {\n    font-size: 12px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/dropdown/dropdown.component.less
// module id = ../../../../../src/app/shared/dropdown/dropdown.component.less
// module chunks = main